import React from "react";
import { useTranslation } from "react-i18next";

import { DateTimeInput } from "../../../common/dateTimeInput";
import { RichTextInput } from "@common/richTextInput";
import { Props } from "./types";
import { TextInput } from "./textInput";
import { SelectList } from "./selectList";
import styles from "./styles.scss";

function ListEditionForm({ formData, lists, editForm }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.listEditionForm}>
      <div className={styles.group}>
        <h3 className={styles.title}>{t("listEdition.nameTitle")}</h3>
        <div className={styles.textInput}>
          <TextInput
            value={formData.name}
            placeholder={t("listEdition.namePlaceholder")}
            input={(name) => editForm({ ...formData, name })}
          />
        </div>
      </div>
      <div className={styles.dateGroup}>
        <div className={styles.row}>
          <h3 className={styles.title}>{t("listEdition.startDateTitle")}</h3>
          <div className={styles.dateTimeInput}>
            <DateTimeInput
              dateTime={formData.startDate}
              placeholder={t("listEdition.startDatePlaceholder")}
              minDate={
                formData.minStartDate
                  ? {
                      year: new Date(formData.minStartDate).getFullYear(),
                      month: new Date(formData.minStartDate).getMonth(),
                      day: new Date(formData.minStartDate).getDate(),
                    }
                  : undefined
              }
              maxDate={(() => {
                const bound = formData.endDate || formData.maxStartDate;
                return bound
                  ? {
                      year: new Date(bound).getFullYear(),
                      month: new Date(bound).getMonth(),
                      day: new Date(bound).getDate(),
                    }
                  : undefined;
              })()}
              input={(startDate) => editForm({ ...formData, startDate })}
            />
          </div>
        </div>
        <div className={styles.row}>
          <h3 className={styles.title}>{t("listEdition.endDateTitle")}</h3>
          <div className={styles.dateTimeInput}>
            <DateTimeInput
              dateTime={formData.endDate}
              placeholder={t("listEdition.endDatePlaceholder")}
              minDate={(() => {
                const bound = formData.startDate || formData.minEndDate;
                return bound
                  ? {
                      year: new Date(bound).getFullYear(),
                      month: new Date(bound).getMonth(),
                      day: new Date(bound).getDate(),
                    }
                  : undefined;
              })()}
              input={(endDate) => editForm({ ...formData, endDate })}
            />
          </div>
        </div>
      </div>
      <div className={styles.group}>
        <h3 className={styles.title}>{t("listEdition.parentListTitle")}</h3>
        <div className={styles.textInput}>
          <SelectList
            items={lists}
            selectedItems={formData.parentList ? [formData.parentList] : []}
            placeholder={t("listEdition.parentListPlaceholder")}
            selectItem={([parentList]) =>
              editForm({
                ...formData,
                parentList,
              })
            }
          />
        </div>
      </div>
      <div className={styles.group}>
        <h3 className={styles.title}>{t("listEdition.descriptionTitle")}</h3>
        <RichTextInput
          value={formData.description}
          maxLength={10000}
          placeholder={t("listEdition.descriptionPlaceholder")}
          input={(description) => editForm({ ...formData, description })}
        />
      </div>
    </div>
  );
}

export { ListEditionForm };
